import{jsx as o}from"react/jsx-runtime";import{calculateRem as n}from"@vds-core/utilities";import e,{keyframes as t,css as i}from"styled-components";import{Component as r}from"react";import{ComponentTokens as d}from"@vds-tokens/component";const l=t`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`,a=t`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`,c=e.div.withConfig({displayName:"Overlay",componentId:"VDS__sc-1i7xx3y-0"})`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${function({$fullScreenDialog:o,viewport:n,surface:e}){return o||"mobile"===n?"transparent":"dark"===e?d.modal.background.overlay.ondark.value:d.modal.background.overlay.onlight.value}};
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  padding: ${function({$fullScreenDialog:o,viewport:e}){return o||"mobile"===e?"0":n(16)}};

  @media (max-width: 767px) {
    padding: 0;
  }

  ${function({$modalOpened:o}){return o&&i`
      animation: ${l} 0.4s
        cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    `}};

  ${function({$unmounted:o}){return o&&i`
      animation: ${a} 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    `}};
`;class u extends r{constructor(){var o;super(...arguments),o=this,this.handleDown=function(n){var e,t;27===n.keyCode&&(null===(t=(e=o.props).onDismiss)||void 0===t||t.call(e))},this.onClick=function(n){var e,t;o.props.disableOutsideClick||n.target.contains(o.overlayRef)&&(null===(t=(e=o.props).onDismiss)||void 0===t||t.call(e))}}componentDidMount(){var o;"undefined"!=typeof document&&(null===(o=null===document||void 0===document?void 0:document.addEventListener)||void 0===o||o.call(document,"keydown",this.handleDown))}componentWillUnmount(){var o;"undefined"!=typeof document&&(null===(o=null===document||void 0===document?void 0:document.removeEventListener)||void 0===o||o.call(document,"keydown",this.handleDown))}render(){var n=this;const{children:e,fullScreenDialog:t,noMobilePadding:i,viewport:r,unmounted:d,modalOpened:l,surface:a}=this.props;return o(c,{$unmounted:d,$modalOpened:l,$fullScreenDialog:t,onMouseDown:this.onClick,noMobilePadding:i,viewport:r,ref:function(o){n.overlayRef=o},surface:a,children:e})}}export{u as default};
